import React from "react";
import { useTranslation } from "react-i18next";

function ContactOffices() {
  const { t } = useTranslation("contact");

  const offices = [
    { key: "varna" },
    { key: "sofia" }
  ];

  return (
    <section className="contact-offices-section" style={{
      backgroundColor: '#ffffff',
      padding: '100px 0'
    }}>
      <div className="container" style={{ maxWidth: '1400px' }}>
        <div className="section-header text-center mb-5">
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '400',
            color: '#1a1a1a',
            marginBottom: '80px',
            fontFamily: 'Montserrat, sans-serif',
            letterSpacing: '-0.02em'
          }}>
            {t('offices.title')}
          </h2>
        </div>

        <div className="row g-4 justify-content-center">
          {offices.map((office, index) => (
            <div 
              key={office.key} 
              className="col-lg-5 col-md-6"
              style={{
                marginBottom: '30px'
              }}
            >
              <div 
                className="office-card"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: 'none',
                  borderRadius: '16px',
                  padding: '50px 40px',
                  height: '100%',
                  transition: 'all 0.3s ease',
                  cursor: 'default'
                }}
              >
                <h3 style={{
                  fontSize: '1.75rem',
                  fontWeight: '400',
                  color: '#1a1a1a',
                  marginBottom: '35px',
                  fontFamily: 'Montserrat, sans-serif',
                  lineHeight: '1.3',
                  letterSpacing: '-0.02em'
                }}>
                  {t(`offices.${office.key}.title`)}
                </h3>

                <div className="office-details" style={{ marginBottom: '30px' }}>
                  <p style={{
                    color: '#6b7280',
                    fontSize: '1.05rem',
                    lineHeight: '1.8',
                    marginBottom: '0',
                    fontWeight: '400'
                  }}>
                    {t(`offices.${office.key}.address`)}
                  </p>
                </div>

                <div className="office-contact" style={{ marginBottom: '30px' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '15px'
                  }}>
                    <svg 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="1.5"
                      style={{
                        width: '20px',
                        height: '20px',
                        color: '#9ca3af',
                        marginRight: '15px',
                        marginTop: '2px',
                        flexShrink: 0
                      }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                    </svg>
                    <a 
                      href={`tel:${t(`offices.${office.key}.phone`)}`}
                      style={{
                        color: '#6b7280',
                        textDecoration: 'none',
                        fontSize: '1.05rem',
                        transition: 'color 0.3s ease',
                        fontWeight: '400'
                      }}
                      onMouseEnter={(e) => e.target.style.color = 'rgb(73, 69, 56)'}
                      onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                    >
                      {t(`offices.${office.key}.phone`)}
                    </a>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'flex-start'
                  }}>
                    <svg 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="1.5"
                      style={{
                        width: '20px',
                        height: '20px',
                        color: '#9ca3af',
                        marginRight: '15px',
                        marginTop: '2px',
                        flexShrink: 0
                      }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                    </svg>
                    <a 
                      href={`mailto:${t(`offices.${office.key}.email`)}`}
                      style={{
                        color: '#6b7280',
                        textDecoration: 'none',
                        fontSize: '1.05rem',
                        transition: 'color 0.3s ease',
                        wordBreak: 'break-word',
                        fontWeight: '400'
                      }}
                      onMouseEnter={(e) => e.target.style.color = 'rgb(73, 69, 56)'}
                      onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                    >
                      {t(`offices.${office.key}.email`)}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Responsive CSS */}
      <style>{`
        @media (max-width: 991px) {
          .contact-offices-section {
            padding: 80px 0 !important;
          }
          .section-header h2 {
            font-size: 2rem !important;
            margin-bottom: 60px !important;
          }
          .office-card {
            padding: 40px 30px !important;
          }
        }

        @media (max-width: 767px) {
          .contact-offices-section {
            padding: 60px 0 !important;
          }
          .section-header h2 {
            font-size: 1.75rem !important;
            margin-bottom: 40px !important;
          }
          .office-card {
            padding: 30px 20px !important;
          }
          .office-card h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
    </section>
  );
}

export default ContactOffices;

